var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeTitleAccent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.561,
    height: 53.896,
    viewBox: "0 0 127.561 53.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764",
    transform: "translate(-1257.393 -126.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ko\\u0142o",
    transform: "translate(1279.717 16.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(52.87 142.886)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 3.969,
    cy: 3.969,
    r: 3.969,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4dcad7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ko\\u0142o-2",
    "data-name": "ko\\u0142o",
    transform: "translate(1326.126 -15.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_761-2",
    "data-name": "Group 761",
    transform: "translate(52.87 142.886)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142-2",
    "data-name": "Ellipse 142",
    cx: 2.479,
    cy: 2.479,
    r: 2.479,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4dcad7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "krzy\\u017Cyk",
    transform: "translate(1173.984 80.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762",
    transform: "translate(122.006 86.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M126.886,69.3a.833.833,0,0,1,1.667,0l.059,3c0,.134.008.5.008.5l.5.009,3,.059a.833.833,0,0,1,0,1.667l-3,.059c-.133,0-.518,0-.518,0s.014.374.012.507l-.059,3a.833.833,0,0,1-1.667,0l-.059-3c0-.133-.028-.5-.028-.5s-.345,0-.478,0l-3-.059a.833.833,0,0,1,0-1.667l3-.059c.134,0,.5,0,.5,0s0-.369,0-.5Z",
    transform: "translate(-122.504 -68.481)",
    fill: "none",
    stroke: "#2ec1cf",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.999,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "krzy\\u017Cyk-2",
    "data-name": "krzy\\u017Cyk",
    transform: "translate(1239.437 57.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_762-2",
    "data-name": "Group 762",
    transform: "translate(122.006 86.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240-2",
    "data-name": "Path 240",
    d: "M125.665,69.07a.6.6,0,0,1,1.2,0l.043,2.164c0,.1.005.359.005.359l.36.006,2.165.043a.6.6,0,0,1,0,1.2l-2.165.043c-.1,0-.373,0-.373,0s.01.27.008.366l-.043,2.165a.6.6,0,0,1-1.2,0l-.043-2.165c0-.1-.02-.363-.02-.363s-.249,0-.345,0l-2.164-.043a.6.6,0,0,1,0-1.2l2.164-.043c.1,0,.363,0,.363,0s0-.267,0-.363Z",
    transform: "translate(-122.504 -68.481)",
    fill: "none",
    stroke: "#2ec1cf",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.999,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ko\\u0142o-3",
    "data-name": "ko\\u0142o",
    transform: "translate(1205.523 27.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_761-3",
    "data-name": "Group 761",
    transform: "translate(52.87 142.886)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142-3",
    "data-name": "Ellipse 142",
    cx: 4.595,
    cy: 4.595,
    r: 4.595,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4dcad7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTitleAccent);
export default __webpack_public_path__ + "static/media/home-title-accent.c604730f.svg";
export { ForwardRef as ReactComponent };